'use strict';

var React = require('react');

const ScrollableContext = /*#__PURE__*/React.createContext(undefined);

exports.ScrollableContext = ScrollableContext;
